import i18n from '@i18next/i18n';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { IGradFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { GradientType } from '@tencent/alloy-renderer-adapter';

const gradFillConfigs = [
    {
        title: i18n.t('线性对角，左上到右下'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            lin: {
                ang: 45,
                scaled: 1,
            },
            pathGradient: {
                path: GradientType.Linear,
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('线性向下'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            lin: {
                ang: 90,
                scaled: 1,
            },
            pathGradient: {
                path: GradientType.Linear,
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('线性对角，右上到左下'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            lin: {
                ang: 135,
                scaled: 1,
            },
            pathGradient: {
                path: GradientType.Linear,
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('从右下角'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            pathGradient: {
                path: GradientType.Radial,
                fillToRect: { b: 0, l: 100, r: 0, t: 100 },
            },
            tileRect: { b: -100, l: 0, r: -100, t: 0 },
        },
    },
    {
        title: i18n.t('从左下角'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            pathGradient: {
                path: GradientType.Radial,
                fillToRect: { b: 0, l: 0, r: 100, t: 100 },
            },
            tileRect: { b: -100, l: -100, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('线性向右'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            lin: {
                ang: 0,
                scaled: 1,
            },
            pathGradient: {
                path: GradientType.Linear,
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('从中心'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            pathGradient: {
                path: GradientType.Radial,
                fillToRect: { b: 50, l: 50, r: 50, t: 50 },
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('线性向左'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            lin: {
                ang: 180,
                scaled: 1,
            },
            pathGradient: {
                path: GradientType.Linear,
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('从右上角'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            pathGradient: {
                path: GradientType.Radial,
                fillToRect: { b: 100, l: 100, r: 0, t: 0 },
            },
            tileRect: { b: 0, l: 0, r: -100, t: -100 },
        },
    },
    {
        title: i18n.t('从左上角'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            pathGradient: {
                path: GradientType.Radial,
                fillToRect: { b: 100, l: 0, r: 100, t: 0 },
            },
            tileRect: { b: 0, l: -100, r: 0, t: -100 },
        },
    },
    {
        title: i18n.t('线性对角，左下到右上'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            lin: {
                ang: 315,
                scaled: 1,
            },
            pathGradient: {
                path: GradientType.Linear,
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('线性向上'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            lin: {
                ang: 270,
                scaled: 1,
            },
            pathGradient: {
                path: GradientType.Linear,
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
    {
        title: i18n.t('线性对角，右下到左上'),
        gradFill: {
            gsList: [{ pos: 0 }, { pos: 50 }, { pos: 100 }],
            lin: {
                ang: 225,
                scaled: 1,
            },
            pathGradient: {
                path: GradientType.Linear,
            },
            tileRect: { b: 0, l: 0, r: 0, t: 0 },
        },
    },
];

const tintColorGsList = [
    { pos: 0, color: { tint: 66000, satMod: 160000 } },
    { pos: 50, color: { tint: 44500, satMod: 160000 } },
    { pos: 100, color: { tint: 23500, satMod: 160000 } },
];
const shadeColorGsList = [
    { pos: 0, color: { shade: 30000, satMod: 115000 } },
    { pos: 50, color: { shade: 67500, satMod: 115000 } },
    { pos: 100, color: { shade: 100000, satMod: 115000 } },
];

export interface IGradFillConfig {
    title: string;
    gradFill: Partial<IGradFill>;
}

export const getGradFillConfigs = (gsList): IGradFillConfig[] =>
    gradFillConfigs.map(gradFillInfo => ({
        ...gradFillInfo,
        gradFill: {
            ...gradFillInfo.gradFill,
            gsList,
        },
    }));
export const getTintGradFillConfigs = (color: ITDColor): IGradFillConfig[] => {
    const colorProps = typeof color.colorValue === 'number' ? { themeKey: color.colorValue } : { rgbaStr: color.colorValue };
    const gsList = tintColorGsList.map(gs => ({
        ...gs,
        color: new TDColor({ ...colorProps, ...gs.color }),
    }));
    return getGradFillConfigs(gsList);
};
export const getShadeGradFillConfigs = (color: ITDColor): IGradFillConfig[] => {
    const colorProps = typeof color.colorValue === 'number' ? { themeKey: color.colorValue } : { rgbaStr: color.colorValue };
    const gsList = shadeColorGsList.map(gs => ({
        ...gs,
        color: new TDColor({ ...colorProps, ...gs.color }),
    }));
    return getGradFillConfigs(gsList);
};
